import { Component, OnInit } from "@angular/core";
import { SurveyService } from "../services/survey.service";
import { SurveyInfo } from "../models/surveyinfo.model";
import { Router } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { DataService } from "../services/GlobalService/data.service";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
})
export class HomeComponent implements OnInit {
  surveyInfoList: SurveyInfo[] = [];
  isIpAllowed: boolean = false;

  constructor(
    private surveyService: SurveyService,
    private router: Router,
    private authService: AuthService,
    private dataService: DataService
  ) {}

  ngOnInit(): void {
    this.surveyService.getSurveyInfos().subscribe((surveyList) => {
      //console.log('SurveyList: ', surveyList);
      this.surveyInfoList = surveyList.filter(f => f.isHidden == false);
      this.authService.isIPAllowed().subscribe((allowed) => {
        this.isIpAllowed = allowed;
        this.surveyInfoList.forEach((s) => {
          if (s.isIPRestricted) {
            s.isIpAllowed = allowed;
          } else {
            s.isIpAllowed = true;
          }
        });
      });
    });
    //this.dataService.currentPageToRedirect$.subscribe(page => {
    //  if (page) {
    //    this.router.navigateByUrl(page);
    //    console.log("Check Home Page Value: ", page);
    //  } else {
    //    this.router.navigateByUrl('/home');
    //  }
    //});
    this.router.navigateByUrl('/home');
  }

  onSurveyClicked(info: SurveyInfo) {
    if(info.surveyUrl == '/survey/covidexposure'){
      this.router.navigateByUrl('/covid-exposure');
    }
    else{
      this.router.navigateByUrl(info.surveyUrl);
    }
  }
}
